import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import DataTable from "react-data-table-component";
import separateNumber from "../../../utils/separateur";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function Commerciaux(){
  const [itemsList,setItemsList] = useState([]);
  const [itemsListFilter,setItemsListFilter] = useState([]);
  const [loading, setLoading] = useState(false);


  const columns = [

    {
      name: "NOM ET PRENOMS",
      selector : row =>( 
        <>
        {/* <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image" /> */}
        <b>{row.NomCommercial}</b>

        </>
      ),
      grow: 3
    },

    {
      name: "NUMERO MARCHAND",
      selector : row => row.NumeroMarchand,
      grow: 3
    },

    {
      name: "CHEF DE VENTE",
      selector : row => row.NomNumeroCV,
      grow: 3
    },

    {
      name: "TERRITOIRES",
      selector : row => row.NomTerritoire,
      grow: 2
    },
    {
      name: "SECTEURS",
      selector : row => row.NomSecteur,
      grow: 2
    },
    {
      name: "OBJECTIF CASHIN",
      selector : row => <b className="text-danger">{separateNumber(row.ObjectifCashin)}</b>
    },
    {
      name: "OBJECTIF CASHOUT",
      selector : row => <b className="text-danger">{separateNumber(row.ObjectifCashOut)}</b>
    },
    {
      name: "OBJECTIF EVD",
      selector : row => <b className="text-success">{separateNumber(row.ObjectifEvd)}</b>,
      grow: 3
    },

    // {
    //   name: "STATUT",
    //   selector : row => (
    //     <>
    //      {row.is_active == 1 && (
    //     <span className="badge bg-success">Actif</span>
    //     )}
    //     {row.status == 0 && (
    //         <span className="badge bg-danger">Inactif</span>
    //     )}
    //     </>
    //   )
    // },



];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE LISTE COMMERCIAUX')){
          navigate('/page-no-found');
      }
  },[user]);

  useEffect(()=>{
    fetchItemsList();
  },[]);
  const fetchItemsList = async ()=>{
    setLoading(true);
    try {
        axios.get(url.base+'/commerciaux',{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                
            },
        }).then((resp)=>{

            if(resp.status == 200){
                setItemsList(resp.data);
                setItemsListFilter(resp.data);
            }
            setLoading(false);
        })
    } catch (error) {
        setLoading(false);
    }
}

const handleFilter=(event)=>{
  const datas = itemsListFilter?.filter(row => row.NomCommercial.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NomSecteur.toLowerCase().includes(event.target.value.toLowerCase()) || row.NomTerritoire.toLowerCase().includes(event.target.value.toLowerCase()) || row.NomZone.toLowerCase().includes(event.target.value.toLowerCase()) || row.NumeroMarchand.toLowerCase().includes(event.target.value.toLowerCase()) )  ;
  setItemsList(datas);
}
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Page</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Listes des commerciaux</p>
                  </a>
                </div>
                
              </div>
              <div class="header-left">
                {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                            <ExportExcel excelData={itemsList} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-success"}/>
                          </div>
                  </div>
                  </div>
                  <div class="card-body">
                    <h4 class="card-title">COMMERCIAUX PAR DECOUPAGE</h4>
                    <div class="table-responsive">
                    <DataTable 
                          highlightOnHover={true}
                          striped
                          // dense={true}
                          columns={columns} 
                          data={itemsList}
                          customStyles={customerStyle}
                          pagination
                          selectableRows
                          progressPending={loading}
                          progressComponent={
                              <>
                              <div class="text-center">
                                  <div class="spinner-border" role="status">
                                  {/* <span class="visually-hidden">Loading...</span> */}
                                  </div>
                              </div>
                              </>
                          } 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}
export default Commerciaux;